import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';


class Pagination extends Component {
    constructor(props) {
        super(props);
        this.state = {
            slicePageStart: 0,
        }
    }

    componentDidMount() {
    }

    onClickPagePrev = () => {
        let pageIdx = this.props.isPage - 1;

        if (this.props.isPage > 0) {
            this.props.onPagination(pageIdx)
            if (pageIdx > 8 && pageIdx % 9 === 0) {
                this.setState({ slicePageStart: this.state.slicePageStart - 10 })
            }
        } else {
            console.log("no less pages")
        }
    }

    onClickPageUnique = (i) => {
        let pageIdx = i.target.innerText - 1;
        if (this.props.isPage != pageIdx) {
            this.props.onPagination(pageIdx)
        }

    }

    onClickPageNext = () => {
        let pageIdx = this.props.isPage + 1;

        if (this.props.isPage < this.props.maxPage - 1) {
            this.props.onPagination(pageIdx)
            if (pageIdx > 9 && pageIdx % 10 === 0) {
                this.setState({ slicePageStart: this.state.slicePageStart + 10 })
            }
        } else {
            console.log("no more pages")
        }
    }

    render() {
        const { maxPage } = this.props;
        let pageList = [];
        let i = 0;
        for (i = 0; i < maxPage; i++) {
            let item = (
                <a onClick={(i) => this.onClickPageUnique(i)} key={i}
                    style={i == this.props.isPage ? { padding: 5, color: "#5c6d71" } : { padding: 5, color: "#aab3b5" }}>
                    {i + 1}
                </a>
            );

            pageList.push(item)
        }
        let slicePages = pageList.slice(this.state.slicePageStart, this.state.slicePageStart + 10)

        return (
            <div id="pagination">
                <a onClick={() => this.onClickPagePrev()}>
                    <img src={"/write/icon_arrow.png"} alt="left" />
                </a>
                <span style={{ cursor: 'pointer' }}>{slicePages}</span>
                <a onClick={() => this.onClickPageNext()}>
                    <img src={"/write/icon_arrow.png"} alt="left" style={{ transform: 'rotate(0.5turn)' }} />
                </a>
            </div>
        );
    }
}



let mapStateToProps = (state) => ({
});

let mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Pagination);

